
import { CHECK_USER_ACTIVITY } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  checkUserActivity,
  checkUserActivityPending,
  checkUserActivityFulfilled,
  checkUserActivityRejected,
} = createAsyncActions(CHECK_USER_ACTIVITY, 'checkUserActivity');


// WEBPACK FOOTER //
// ./src/actions/checkUserActivityActions.js